import Typography from '@mui/material/Typography'
import moment from 'moment'
import CurrencySingleValue from '../../../components/bankAccount/currency/singleValue'
import PaymentRequestDropDown from '../../../components/bankAccount/paymentRequests/PaymentRequestDropDown'
import PaymentRequestsActions from '../../../components/bankAccount/paymentRequests/PaymentRequestsActions'
import TableWithLoadingWrapper from '../../generic/dataGrid'

const PaymentsRequestsTable = (props) => {
  const columns = [
    {
      field: 'created_timestamp',
      headerName: 'Date',
      flex: 1,
      renderCell: (params) => {
        const date = params?.row?.created_timestamp
        const formattedDate = date ? moment(date).format('YYYY-MM-DD') : 'N/A'
        return <span>{formattedDate}</span>
      },
      valueGetter: (params) => {
        const date = new Date(params)
        return date.toLocaleString()
      },
      sortComparator: (v1, v2) => {
        if (!v1) return 1 // Nulls come last
        if (!v2) return -1 // Nulls come last
        return new Date(v2) - new Date(v1) // Sort in descending order
      },
    },
    {
      field: 'created_by',
      headerName: 'To/From',
      flex: 1,
      renderCell: (params) => (
        <Typography sx={{ textTransform: 'capitalize' }} variant='primary'>
          {params?.row?.counterparty_name} / {params?.row?.created_by}
        </Typography>
      ),
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 2,
      renderCell: (params) => (
        <Typography sx={{ textTransform: 'capitalize' }} variant='primary'>
          {params?.row?.description}
        </Typography>
      ),
    },
    {
      field: 'type',
      headerName: 'Method',
      flex: 1,
      renderCell: (params) => <Typography variant='primary'>{params?.row?.method}</Typography>,
    },
    {
      field: 'amount',
      headerName: 'Amount',
      flex: 1,
      renderCell: (params) => {
        let scalar = 1
        // logic for single bank account display
        if (props.bankAccountId === params?.row?.from_bank_account) {
          scalar = -1
        }
        return (
          <CurrencySingleValue
            amount={scalar * params?.row?.amount}
            currency='USD'
            currencySymbol={params?.row?.attributes?.currency_symbol}
          />
        )
      },
    },
    {
      field: 'actions',
      headerName: '',
      flex: 1,
      renderCell: (params) => {
        return (
          <PaymentRequestsActions paymentRequest={params.row} updatePaymentRequests={props.updatePaymentRequests} />
        )
      },
    },
    {
      field: 'dropdown',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        return (
          <PaymentRequestDropDown paymentRequest={params.row} updatePaymentRequests={props.updatePaymentRequests} />
        )
      },
    },
  ]

  return (
    <TableWithLoadingWrapper
      checkboxSelection={props.onRowSelect ? true : false}
      onRowSelectionModelChange={props.onRowSelect}
      loading={props.loading}
      pagination={{
        paginationModel: {
          pageSize: props.defaultPageSize ? props.defaultPageSize : 25,
          page: props.defaultPage ? props.defaultPage : 0,
        },
      }}
      pageSizeOptions={[5, 10, 25]}
      getRowId={(record) => record.id}
      columns={columns}
      dataSource={props.paymentRequests}
      sortModel={[
        {
          field: 'created_timestamp',
          sort: 'asc',
        },
      ]}
    />
  )
}

export default PaymentsRequestsTable
